// extracted by mini-css-extract-plugin
module.exports = {"root":"FileDropZone_root__HX_mq","dropContainer":"FileDropZone_dropContainer__1R96f","dragOverlay":"FileDropZone_dragOverlay__2C_HX"};